<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="7" cy="12" r="1" fill="currentColor"></circle>
    <circle cx="12" cy="12" r="1" fill="currentColor"></circle>
    <circle cx="17" cy="12" r="1" fill="currentColor"></circle>
  </svg>
</template>
